export const DEFAULT_VISITOR_NAME = 'Unnamed customer';
export const DEFAULT_AGENT_NAME = 'Unnamed agent';
export const UNNAMED_AUTHOR = 'Unnamed author';
export const AUTOMATIC_MESSAGE = 'Automatic message';
